import { gpsUnitsVar } from 'modulesCommon/store'
import { useGetGpsUnitsQuery } from '../graphql/queries/getGpsUnits.types'
import { TSelectOption } from 'shared/types'
import { useReactiveVar } from '@apollo/client'

export const useGpsUnits = ()  => {
  const gpsUnits = useReactiveVar(gpsUnitsVar)

  const { loading: gpsUnitsLoading, error: gpsUnitsError } = useGetGpsUnitsQuery({
    onCompleted: (data) => {
      const gpsOptions = (data.getGpsUnits || []).map(
        (unit): TSelectOption => ({ value: unit?.alias ?? '', label: unit?.name ?? '' }))
      gpsUnitsVar(gpsOptions)
    }
  })

  return {
    gpsUnits,
    gpsUnitsLoading,
    gpsUnitsError
  }
}

export default useGpsUnits
